import LogicaAPI from "./logicaapi";
class Purchase extends LogicaAPI {
  async purchaseExecute(_ref) {
    let {
      productId,
      paymentInstrumentId,
      voucherCode
      // userVoucherId,
    } = _ref;
    const params = {
      product_id: productId,
      payment_instrument_id: paymentInstrumentId,
      with_order: true
    };
    if (voucherCode) {
      params.voucher_code = voucherCode;
    }

    // if (!!userVoucherId) {
    //   params.user_voucher_id = userVoucherId;
    // }

    console.log("args", {
      productId,
      paymentInstrumentId,
      voucherCode
      // userVoucherId,
    });

    console.log("purchaseExecute", params);
    const res = this.post("/api/v1/purchase/execute", {
      body: params
    });
    return res;
  }
  estimate(_ref2) {
    let {
      productId,
      paymentMethodId,
      voucherCode /*userVoucherId*/
    } = _ref2;
    const params = {
      product_id: productId,
      payment_method_id: paymentMethodId
    };
    if (voucherCode) {
      params.voucher_code = voucherCode;
    }
    // if (userVoucherId) {
    //   params.user_voucher_id = userVoucherId;
    // }
    return this.post("/api/v1/purchase/estimate", {
      body: params
    });
  }
}
export default Purchase;